export default __webpack_public_path__ + "static/media/minus.a9c37632.svg";